import { Base } from "@/components/Store/StoreSearchInput/components/base";
import { Input } from "@/components/Store/StoreSearchInput/components/input";
import { Location } from "@/components/Store/StoreSearchInput/components/location";
import { SearchButton } from "@/components/Store/StoreSearchInput/components/searchButton";

export const StoreSearchInput = Object.assign(Base, {
    Input: Input,
    SearchButton: SearchButton,
    Location: Location
});
